window.mountSplideInGrid = function (context = document) {
  const spliders = context.querySelectorAll(".splide:not(.is-mounted)");

  if (!spliders.length) return; // no splide elements, skip

  spliders.forEach(function (splideEl) {
    const isHero = splideEl.classList.contains("splide__hero");

    const splide = new Splide(splideEl, {
      perPage: 1,
      pagination: false,
      arrows: true,
      drag: true,
      type: isHero ? "loop" : "slide", // only enable looping on hero
      autoplay: isHero,
      interval: 5000, // 5 seconds between slides
    });

    let isDragging = false;

    splide.on("drag", function () {
      isDragging = true;
    });

    splide.on("dragged", function () {
      setTimeout(function () {
        isDragging = false;
      }, 50);
    });

    splide.mount();
    splideEl.classList.add("is-mounted");

    splideEl.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", function (e) {
        if (isDragging) {
          e.preventDefault();
        }
      });
    });
  });
};
